var _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 2,
    height: 10,
    rx: 1,
    fill: "#213555"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4,
    width: 2,
    height: 10,
    rx: 1,
    transform: "rotate(90 10 4)",
    fill: "#213555"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSI+DQo8cmVjdCB4PSI0IiB3aWR0aD0iMiIgaGVpZ2h0PSIxMCIgcng9IjEiIGZpbGw9IiMyMTM1NTUiLz4NCjxyZWN0IHg9IjEwIiB5PSI0IiB3aWR0aD0iMiIgaGVpZ2h0PSIxMCIgcng9IjEiIHRyYW5zZm9ybT0icm90YXRlKDkwIDEwIDQpIiBmaWxsPSIjMjEzNTU1Ii8+DQo8L3N2Zz4=";
export { SvgIconPlus as ReactComponent };